// Generated by purs version 0.15.4
import * as Control_Apply from "../Control.Apply/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Show from "../Data.Show/index.js";
var map = /* #__PURE__ */ Data_Functor.map(Data_Maybe.functorMaybe);
var apply = /* #__PURE__ */ Control_Apply.apply(Data_Maybe.applyMaybe);
var SortedArray = function (x) {
    return x;
};
var toArray = function (v) {
    return v;
};
var tail = function (xs) {
    return map(SortedArray)(Data_Array.tail(toArray(xs)));
};
var showSortedArray = function (dictShow) {
    return {
        show: (function () {
            var $29 = Data_Show.show(Data_Show.showArray(dictShow));
            return function ($30) {
                return $29(toArray($30));
            };
        })()
    };
};
var length = function ($31) {
    return Data_Array.length(toArray($31));
};
var index = function ($32) {
    return Data_Array.index(toArray($32));
};
var head = function (xs) {
    return Data_Array.head(toArray(xs));
};
var uncons = function (xs) {
    return apply(map(function (x) {
        return function (y) {
            return {
                head: x,
                tail: y
            };
        };
    })(head(xs)))(tail(xs));
};
var insert = function (dictOrd) {
    var lessThanOrEq = Data_Ord.lessThanOrEq(dictOrd);
    return function (x) {
        return function (v) {
            var v1 = uncons(v);
            if (v1 instanceof Data_Maybe.Nothing) {
                return [ x ];
            };
            if (v1 instanceof Data_Maybe.Just) {
                var $21 = lessThanOrEq(x)(v1.value0.head);
                if ($21) {
                    return Data_Array.cons(x)(v);
                };
                return insert(dictOrd)(v1.value0.head)(insert(dictOrd)(x)(v1.value0.tail));
            };
            throw new Error("Failed pattern match at PartyCarlo.Data.SortedArray (line 67, column 33 - line 72, column 35): " + [ v1.constructor.name ]);
        };
    };
};
var sortedArraySemigroup = function (dictOrd) {
    var insert1 = insert(dictOrd);
    return {
        append: function (xs) {
            return function (ys) {
                var v = uncons(ys);
                if (v instanceof Data_Maybe.Nothing) {
                    return xs;
                };
                if (v instanceof Data_Maybe.Just) {
                    return Data_Semigroup.append(sortedArraySemigroup(dictOrd))(insert1(v.value0.head)(xs))(v.value0.tail);
                };
                throw new Error("Failed pattern match at PartyCarlo.Data.SortedArray (line 28, column 20 - line 30, column 60): " + [ v.constructor.name ]);
            };
        }
    };
};
var fromArray = function (dictOrd) {
    var sort = Data_Array.sort(dictOrd);
    return function (xs) {
        return sort(xs);
    };
};
var foldableSortedArray = Data_Foldable.foldableArray;
var filter = function (xs) {
    return function (f) {
        return Data_Array.filter(f)(toArray(xs));
    };
};
var empty = [  ];
export {
    empty,
    filter,
    fromArray,
    head,
    index,
    insert,
    length,
    tail,
    toArray,
    uncons,
    sortedArraySemigroup,
    foldableSortedArray,
    showSortedArray
};
